// extracted by mini-css-extract-plugin
export default {"tableHeader":"CreditList_tableHeader__-OQQo","plus":"CreditList_plus__QSQMN"};